import React from 'react';
import classnames from 'classnames';
import styles from './AlgorithmCheckbox.module.css';

const createMarkup = text => {
  return {__html: text.replace(/\n/g,'<br>')}
};

const AlgorithmCheckbox = ({componentBlock, contentData, id, changeData, title}) => (
  <div
    className={classnames({
      [styles.wrap]: componentBlock.visibility,
      [styles.visibility]: !componentBlock.visibility
    })}
  >
    <div>
      {contentData.map(item => (
        <div key={item.key}>
          <input type="checkbox" id={title}/>
          <label htmlFor={title}>
            <div dangerouslySetInnerHTML={this.createMarkup(title)}/>
          </label>
        </div>
      ))}  
    </div>
  </div>
);

export default AlgorithmCheckbox;